import { useEffect, useMemo, useState } from "react";
import { menus as defaultMenu } from "../menuData";
import { masterMenus } from "../menuData.master";
import { readUser, readAllowed, can } from "../utils/perm";

const filterMenusByPerm = (groups, allowed) =>
  (groups || [])
    .map((g) => ({
      ...g,
      items: (g.items || []).filter((it) => can(it.page || it.label, "View")),
    }))
    .filter((g) => (g.items || []).length > 0);

export default function useMenus() {
  const [role, setRole] = useState(() => readUser()?.rolename?.roleName || "");
  const [tick, setTick] = useState(0); // trigger recompute

  const base = useMemo(
    () => (role === "MASTER" ? masterMenus : defaultMenu),
    [role]
  );

  const menus = useMemo(() => {
    if (role === "MASTER") return base;
    const allowed = readAllowed();
    return filterMenusByPerm(base, allowed);
  }, [base, tick]);

  useEffect(() => {
    const recompute = () => {
      setRole(readUser()?.rolename?.roleName || "");
      setTick((x) => x + 1);
    };
    const onStorage = (e) => {
      if (e.key === "userData" || e.key === "allowedPermission") recompute();
    };
    const onUD = () => recompute();
    const onAP = () => recompute();

    window.addEventListener("storage", onStorage);
    window.addEventListener("userData:updated", onUD);
    window.addEventListener("allowedPermission:updated", onAP);
    recompute();
    return () => {
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("userData:updated", onUD);
      window.removeEventListener("allowedPermission:updated", onAP);
    };
  }, []);

  return menus;
}
